module.exports = "<div style=\"position: fixed; left: 50%; transform: translateX(-50%); top: 0;\">\r\n    <div *ngFor=\"let team of teams; let i = index\">\r\n        <span>{{team.name}}</span>\r\n        <input [(ngModel)]=\"order[i]\" type=\"number\">\r\n    </div>\r\n    <button (click)=\"onOrderChange.emit(order)\">Change order</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/order/order.component.html
// module id = ./src/app/components/order/order.component.html
// module chunks = main